import { atom } from "recoil";

export const Airlines = new atom({ key: "Airlines", default: [] });
